export default obj => Object
  .keys(obj)
  .filter(prop => !!obj[prop])
  .join(' ');
